import { render, staticRenderFns } from "./KusHomePublicPasswordLostBtn.vue?vue&type=template&id=08141487"
import script from "./KusHomePublicPasswordLostBtn.vue?vue&type=script&lang=js"
export * from "./KusHomePublicPasswordLostBtn.vue?vue&type=script&lang=js"
import style0 from "./KusHomePublicPasswordLostBtn.vue?vue&type=style&index=0&id=08141487&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports